import React, { useEffect, useState } from "react";
import * as utils from "../../Utils/comman";
import * as RB from "react-bootstrap";
import Select from "react-select";

function Capital({selectedCer, setselectedCer,props}) {
  const [cerList, setcerList] = useState([]);

  useEffect(() => {
    getCERNo();
  }, []);

  const getCERNo = () => {
    utils
      .callAPI("get", `cer/list?page=${0}&per_page=${0}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setcerList(res);
        } else {
          setcerList([]);
        }
      })
      .catch((err) => {
        setcerList([]);
      });
  };

  const options = cerList?.result?.map((prod) => ({
    value: prod?.id,
    label: prod?.cer_no,
  }));


  const handleCerSelection = (selected) => {
    console.log(selected)
    if (selected) {
      setselectedCer(selected);
    }
  };

  useEffect(()=>{
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setselectedCer({
        value: props?.rowData?.cer_id,
        label: props.rowData?.cer_no,
      })
    }

  },[props?.rowData])
  return (
    <>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="productName"
            className="floating-label-fancy"
            label="Select CER No"
          >
            <Select
              options={options}
              value={selectedCer}
              onChange={handleCerSelection}
              placeholder="Select CER No"
              className="bom-productName-select"
              classNamePrefix="select"
              isClearable
              required
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
    </>
  );
}

export default Capital;
